import { RegularExpressions } from "../../helpers/constants";
import { between, validateWhiteSpace } from "../../helpers/GlobalFunctions";
import { deviceMessages } from "../../helpers/messages";

/**
 * @description function for validate each input field
 * @param stateObj Current state object
 * @returns Object with error messages
 */
 export const validateDeviceFields = (stateObj, fields = ['slNo', 'deviceType', 'customerID']) => {
    var { errors, editObj } = stateObj;
    var errorFlag = false;
    for (let i = 0; i < fields.length; i++) {
        const field = fields[i];
        const reWhiteSpace = new RegExp(/^\s+$/);
        if (!editObj[field] || reWhiteSpace.test(editObj[field]) === true) {
            errorFlag = true;
            errors[field] = deviceMessages[field];
        } else if (field === 'slNo' && editObj[field] && !between(editObj[field].length, 3, 13)) {
            errorFlag = true;
            errors[field] = deviceMessages.slNoLength;
            break;
        } else {
            errors[field] = '';
        }
    }

    return { errorFlag, errors };
}

/**
 * @description function for validate Alphanumeric
 * @param value Alphanumeric fields
 * @returns Object with error messages
 */
 export const validateAlphanumeric = (value) => {
    if (validateWhiteSpace(value)) {
        return { errorFlag: true, error: deviceMessages.whiteSpace }
    }
    
    var errorFlag = !RegularExpressions.alphanumericNoSpace.test(value);
    return { errorFlag: errorFlag ? true : false, error: errorFlag ? deviceMessages.slNoAlphaNumeric : '' }
}